import api, {
    setToken,
    WORKSPACE_ID_PADRAO
} from '@/common/api.js'
import router from '@/router'

/* eslint-disable */

export default {
    namespaced: true,

    state: {
        categoriaSelecionada: {},
        categories: {},
        menus: {},
        empresas: {},
        filial: {},
        empresaColaborador: {},
        exibeBemVindo: true,
        credenciais: 'Carregando'
    },

    getters: {
        filteredMovies: (state) => state.filteredMovies,
        filteredCategories: (state) => {
            return state.filteredCategories
        },
        getMenus: (state) => {
            return state.menus
        },
        getEmpresas: (state) => state.empresas,
        filial: (state) => state.filial,
        getEmpresaColaborador: (state) => state.empresaColaborador,
        getExibeBemVindo: (state) =>state.exibeBemVindo,
        getCredenciais: (state) =>state.credenciais
    },

    actions: {
        async getMenus({
            commit
        }) {
            const paisSelecionado = localStorage.getItem('paisSelecionado');
            const params = {};
            if (paisSelecionado) {
                params.pais = paisSelecionado;
            }
            const response = await api.get('/portal-bi/getMenus', { params })

            commit("setMenus", response.data.menus);
        },
        selectCategory({
            state
        }, type) {
            state.categoriaSelecionada = type

        },
        async getEmpresasBusca({
            commit
        }) {
            try {
                const params = {
                    mostrar_em: 3
                }

                const response = await api.get('/getEmpresas', {
                    params
                })

                commit('setEmpresas', response.data)
                return response
            } catch (error) {
                throw Error(error)
            }
        },
        async doLogin({
            commit
        }, {
            data
        }) {
            try {
                // console.log(data)
                const response = await api.post('/doLoginBi', data)

                const filial = {
                    ...response.data,
                    token: response.data.token,
                    tecnicoId: response.data.tecnicoId,
                    dsColaborador: response.data.dsColaborador,
                    infColab: data,
                    foto: response.data.foto,
                    empresa: response.data.empresa,
                    filial: response.data.filial,
                }
                // console.log(filial)
                commit('setFilial', filial)
                return response
            } catch (error) {
                throw Error(error)
            }
        },
        async salvarLog({commit}, {data}){
            try {
                const response = await api.post('/portal-bi/salvarLogs', data)
                
                commit("setEmpresaColaborador", response.data.empresa_colaborador);
                return response
            } catch (error) {
                throw new Error(error)
              }
        },
        loadFromLocalStorage: ({commit, state }) => {
            if (localStorage.filial) {
                const filial = JSON.parse(localStorage.filial)

                if (filial.token) {
                    commit('setFilial', filial)
                }
            }
        },
        async logout({ commit, state }) {
            try {
                commit('unsetFilial')
            } catch (error) {
                throw new Error(error)
            }
        },
        async getCredenciais({commit}){
            try {
                const response = await api.get('/portal-bi/getCredenciais')

                commit('setCredenciais', response.data)
                return response
            } catch (error) {
                throw new Error(error)
            }
        },
        async getEmbedded({commit}, {link}){
            try {
                // console.log(link)
                const params = {
                    link: link
                }
                const response = await api.get('/portal-bi/getEmbedded', { params })

                return response.data
            } catch (error) {
                console.log(error)
            }
        },
        async perguntarChatBI({ commit }, { pergunta, reportId, workspaceId, conversaId }) {
            try {
                const data = {
                    pergunta,
                    reportId,
                    workspaceId: workspaceId || WORKSPACE_ID_PADRAO
                }

                // Só manda conversaId quando já existe uma conversa em andamento —
                // sem isso o backend cria uma conversa nova.
                if (conversaId) {
                    data.conversaId = conversaId
                }

                const response = await api.post('/chat/bi', data)

                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async listarConversasChat() {
            try {
                const response = await api.get('/chat/conversas')

                return response.data.conversas
            } catch (error) {
                throw new Error(error)
            }
        },
        async carregarMensagensConversa({ commit }, { conversaId }) {
            try {
                const response = await api.get(`/chat/conversas/${conversaId}/mensagens`)

                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async verificarAcessoChat() {
            try {
                const response = await api.get('/chat/acesso')

                return !!response.data.liberado
            } catch (error) {
                return false
            }
        },
        async avaliarMensagemChat({ commit }, { mensagemId, feedback }) {
            try {
                const response = await api.post(`/chat/mensagens/${mensagemId}/feedback`, { feedback })

                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getNoticias(){
            try {
                const response = await api.get('/portal-bi/getNoticias')

                return response
            } catch (error) {
                throw new Error(error)
            }
        },
        async salvarNoticia({commit}, {data}){
            try {
                const response = await api.post('/portal-bi/salvarNoticia', data)
                
                return response
            } catch (error) {
                throw new Error(error)
              }
        },
        async updateOrdemNoticias({commit}, {data}){
            try {
                const response = await api.post('/portal-bi/updateOrdemNoticias', data)
                
                return response
            } catch (error) {
                throw new Error(error)
              }
        },
        async updateNoticia({commit}, {data}){
            try {
                const response = await api.post('/portal-bi/updateNoticia', data)
                
                return response
            } catch (error) {
                throw new Error(error)
              }
        },
        async enviarAvaliacao({ commit }, { data }) {
            try {
                const response = await api.post(`/portal-bi/enviarAvaliacao`, { ...data })

                return response
            } catch (error) {
                throw new Error(error)
            }
        },
    },

    mutations: {
        setMenus(state, data) {
            state.menus = data;
        },
        setEmpresaColaborador(state, data) {
            state.empresaColaborador = data;
        },
        setFilteredMovies(state, movies) {
            state.filteredMovies = movies;
        },
        setEmpresas(state, empresas) {
            state.empresas = empresas
        },
        setFilial(state, filial) {
            localStorage.filial = JSON.stringify(filial)
            setToken(api)
            state.filial = filial
        },
        unsetFilial(state) {
            localStorage.removeItem('filial')
            localStorage.removeItem('menuSelecionado')
            state.filial = null
            router.push('/login')
        },
        setBemVindo(state, valor) {
            state.exibeBemVindo = valor
        },
        setCredenciais(state, credenciais) {
            state.credenciais = credenciais
        }
    }
}